import App from 'app/app.js';
import LtSelectionDrawerCtrl from 'app/directive/LtSelectionDrawerCtrl.js';

function LtOrderMoreDrawerCtrl($scope, $timeout) {
  LtSelectionDrawerCtrl.call(this, $scope, $timeout);

  this.loadSubject = function () {
    var formData = { formData: { portraitId: this.portraitId, accessCode: this.accessCode } };
    $scope.onLoadSubject(formData);
  };
}

App.controller('LtOrderMoreDrawerCtrl', ['$scope', '$timeout', LtOrderMoreDrawerCtrl]);
